<div class="p-4 side" [ngClass]="'open'" style="left: 0px; top: 60px; margin-left: -15px">
  <div class="row justify-content-center" style="margin-top: 72px !important">
    <button
      [ngClass]="'btn btn-primary btn-icon-open'"
      routerLink="/logs"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="fa-regular fa-bells fa-lg" style="width: 30px"></i>
      <a style="font-size: 16px; text-transform: capitalize">{{ 'Notificações' }}</a>
    </button>
  </div>
  <div class="row justify-content-center my-4">
    <button
      [ngClass]="'btn btn-primary btn-icon-open'"
      routerLink="/logs/sharing"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="fa-regular fa-message-lines fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">{{ 'Compartilhamento' }}</a>
    </button>
  </div>
  <div class="sidebar-footer">
    <img [src]="org?.imageURL ?? 'assets/icons/camera.svg'" class="org-img" />
    <div class="d-flex">
      <span style="font-size: 11px; line-height: 15px">{{ org?.name ?? 'Organização não informada' }}</span>
    </div>
  </div>
</div>
